import type { PromocodeUpdateValues, Promocode } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { usePromocodesStore } from '../model/store'

interface PromocodeUpdateOptions {
  promocodeId: string | number
  payload: PromocodeUpdateValues
}

/**
 * `PATCH /admin-api/promocodes/{promocode}` — update a promocode's status and expiry.
 */
export const usePromocodeUpdate = async (options: PromocodeUpdateOptions): Promise<Promocode | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = usePromocodesStore()

  const url = useAdminRoutes('admin.promocode.update', { promocode_id: options.promocodeId })

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.patch<ApiResponse>(url, options.payload)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    toast.success(data.message)

    return data.data || null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setSaving(false)
  }
}
